import React, { lazy, Suspense } from 'react';
import { useTheme } from '@/lib/useTheme';
import Header from '@/components/marketing/Header';
import HeroSection from '@/components/marketing/HeroSection';
import ScrollToTop from '@/components/marketing/ScrollToTop';
import FloatingChat from '@/components/marketing/FloatingChat';
import CookieBanner from '@/components/marketing/CookieBanner';

// Below-the-fold sections load on demand so the initial JS payload (and the
// script-eval / main-thread work that blocks first paint) stays small.
// Each section gets its own Suspense boundary so chunks stream independently.
const TrustSection = lazy(() => import('@/components/marketing/TrustSection'));
const ProductOverview = lazy(() => import('@/components/marketing/ProductOverview'));
const FeaturesGrid = lazy(() => import('@/components/marketing/FeaturesGrid'));
const AIFeatures = lazy(() => import('@/components/marketing/AIFeatures'));
const CTASection = lazy(() => import('@/components/marketing/CTASection'));
const Footer = lazy(() => import('@/components/marketing/Footer'));

const Below = ({ children }) => (
  <Suspense fallback={null}>{children}</Suspense>
);

export default function Home() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="min-h-screen bg-background text-foreground overflow-x-hidden">
      <Header theme={theme} setTheme={setTheme} />
      <main>
        <HeroSection />
        <Below><TrustSection /></Below>
        <Below><ProductOverview /></Below>
        <Below><FeaturesGrid /></Below>
        <Below><AIFeatures /></Below>
        <Below><CTASection /></Below>
      </main>
      <Below><Footer /></Below>
      <ScrollToTop />
      <FloatingChat />
      <CookieBanner />
    </div>
  );
}